<template>
  <div class="reportApplication">
    <commonHeader :explain="explain" :title="pageTitle" />
    <!-- 基本信息 -->
    <qdBasicInformation v-if="!$route.query.activityCode || editEchoData" ref="basicInformationRef"
      :edit-echo-data="editEchoData" />
    <!-- 费用归属 -->
    <!-- !$route.query.activityCode：表示不是编辑页 -->
    <!-- editEchoData：表示是编辑页并且请求数据成功 -->
    <!-- !needOrganizer：表示没有活动组支持 -->
    <!-- addCostEditFlag：表示活动组支持追加的费用可编辑 -->
    <costAscription ref="costAscriptionRef"
      v-if="(!$route.query.activityCode || editEchoData) && (!needOrganizer || addCostEditFlag)"
      :edit-echo-data="editEchoData" />
    <!-- 活动附件 -->
    <activityFile ref="activityFileRef" v-if="!$route.query.activityCode || editEchoData"
      :edit-echo-data="editEchoData" />
    <div class="buttons">
      <el-button plain @click="saveBtn" v-if="saveBtnShow">{{ $t('btn.SaveD') }}</el-button>
      <el-button type="primary" @click="submitBtn">{{ $t('btn.Submit') }}</el-button>
    </div>
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader';
import qdBasicInformation from './component/newApplicationForm/qdBasicInformation';
import costAscription from './component/newApplicationForm/costAscription';
import activityFile from './component/newApplicationForm/activityFile';
import { newApplicationFormApi } from './service';
import { hasAllsmartOrder, confirmAllsmartOrderTimeout } from '@/utils/allsmartOrderCheck';
import { confirmPrecheck, confirmBusiness, notifyDetectFailed } from '@/utils/exportComplianceDialog';
import { mapState } from 'vuex';
import {isNotEmpty, throttle, throttleAsync} from '../../utils/utils';

export default {
  data () {
    return {
      pageTitle: this.$t('home.ca'),
      explain: {
        text: `${this.$t('notic.AppRule')}，`,
        content: this.$t('notic.AppRuleOne')
      },
      editEchoData: null,
      addCostEditFlag: false, // 活动组支持追加的费用是否可编辑
      saveBtnShow: false,
      isSubmitted: false // 是否已提交：false离开页面会有提示保存信息
    };
  },
  computed: {
    ...mapState({
      needOrganizer: (state) => state.newApplication.needOrganizer
    })
  },
  components: {
    commonHeader,
    qdBasicInformation,
    costAscription,
    activityFile
  },
  methods: {
    paramsHandler (saveType) {
      // saveType 保存类型 1-草稿  2-提交  3-品推编辑  4-驳回编辑  5-报备提交   6-报备草稿

      let params = {
        // 保存类型
        saveType: saveType
      };
      // 基本信息
      let basicInfoData = this.$refs.basicInformationRef.formData;

      params.marketActivity = {
        // submitType 提交类型(页面类型) quick_submit-快速提交  普通提交-normal_submit  报备提交-report_submit  渠道提交-qd_submit
        submitType: 'qd_submit',
        // 基本信息
        activityCode: basicInfoData.activityCode,
        financialSystemCode: basicInfoData.financialSystemCode,
        financialSystemName: basicInfoData.financialSystemName,
        currencyCode: basicInfoData.currencyCode,
        currencyType: basicInfoData.currencyType,
        currFromRmbRate: basicInfoData.currFromRmbRate,
        applyUserTel: basicInfoData.applyUserTel,
        applyTime: basicInfoData.applyTime,
        salerId: basicInfoData.salerId,
        salerName: basicInfoData.salerName,
        salerDeptCode: basicInfoData.salerDeptCode,
        salerDeptName: basicInfoData.salerDeptName,
        applyUserId: basicInfoData.applyUserId,
        applyUserName: basicInfoData.applyUserName,
        applyUserDeptCode: basicInfoData.applyUserDeptCode,
        applyUserDeptName: basicInfoData.applyUserDeptName,
        applyUserType: basicInfoData.applyUserType,
        activityName: basicInfoData.activityName,
        activityGoal: basicInfoData.activityGoal,
        otherClassification: basicInfoData.otherClassification,
        businessUnit: basicInfoData.businessUnitDisplayed ? basicInfoData.businessUnitDisplayed.join(',') : '',
        activityClassificationCode: basicInfoData.activityClassificationCode,
        activityClassification: basicInfoData.activityClassification,
        relatedActivityCode: basicInfoData.relatedActivityCode,
        relatedActivityName: basicInfoData.relatedActivityName,
        activityForms: basicInfoData.activityForms,
        organizer: basicInfoData.organizer,
        inviterNum: basicInfoData.inviterNum,
        targetObject: basicInfoData.targetObject,
        activityTypeCode: basicInfoData.activityTypeCode,
        activityType: basicInfoData.activityType,
        qdMeetingSegment: basicInfoData.qdMeetingSegment,
        city: basicInfoData.city,
        expectStartDate: basicInfoData.expectStartDate,
        expectEndDate: basicInfoData.expectEndDate,
        isUnionMarket: basicInfoData.isUnionMarket,
        isInternationalQd: basicInfoData.isInternationalQd,
        unionChannelType: basicInfoData.unionChannelType,
        unionChannelName: basicInfoData.unionChannelName,
        needOrganizer: basicInfoData.needOrganizer,
        budgetAmount: basicInfoData.budgetAmount,
        organizerReason: basicInfoData.organizerReason
      };
      if (isNotEmpty(basicInfoData.mactCommunicationScenarioList)) {
        params.mactCommunicationScenarioList = basicInfoData.mactCommunicationScenarioList;
      }
      if (isNotEmpty(basicInfoData.mactAgendaList)) {
        params.mactAgendaList = basicInfoData.mactAgendaList;
      }

      // 活动信息-扩展表（后续新增的字段）
      params.marketActivityExpand = {
        activityCode: basicInfoData.activityCode,
        activityBackgroundPurpose: basicInfoData.activityBackgroundPurpose
      };

      // 所属行业方案
      if (basicInfoData.viewIndustryAgenda.length > 0) {
        basicInfoData.industryAgenda = this.$refs.basicInformationRef.industryAgendaFilter();
      }

      // 活动预计包含板块
      params.mactModuleList = this.$refs.basicInformationRef.plateFilter();

      // 产品线
      params.mactProductLineList = this.$refs.basicInformationRef.productlineSupplementFilter();

      // 渠道没有 拟邀客户
      params.mactJoinCustomerList = [];

      // 费用归属
      // 如果不是活动组支持 || 是活动组支持追加的费用可编辑
      if (!this.needOrganizer || this.addCostEditFlag) {
        params.mactExpenseBelongVOList = this.$refs.costAscriptionRef.tableData.map(item => {
          return {
            mactExpenseBelong: {
              ...item,
              activityCode: basicInfoData.activityCode
            },
            activityExpenseDetails: item.activityExpenseDetails,
            advertiseExpenseDetails: item.advertiseExpenseDetails
          };
        });
        // 费用归属总计
        params.marketActivity.totalCost = this.$refs.costAscriptionRef.costTotal;
      } else {
        params.mactExpenseBelongVOList = [];
      }

      // 活动附件
      if (this.$refs.activityFileRef.fileList.length > 0) {
        params.attachFileList = this.$refs.activityFileRef.fileList.map(item => {
          return {
            fileId: item.response ? item.response.data[0].FID : item.fileId,
            fileName: item.name,
            activityCode: basicInfoData.activityCode,
            sourceType: 'Activity'
          };
        });
      }
      return params;
    },
    validateScrollJump (ele, scrollbarData) {
      let eleInfo = ele.$el.getBoundingClientRect();
      if (eleInfo.top < 0) {
        scrollbarData.scrollTop = scrollbarData.scrollTop - (eleInfo.height / 2) - Math.abs(eleInfo.top);
      }
    },
    async subValidate () {
      let mainScrollbar = document.querySelector('.contentScrollbar>.el-scrollbar__wrap');
      // 基本信息校验
      let basicInfoValidate = await this.$refs.basicInformationRef.validateHandler();
      if (!basicInfoValidate) {
        this.validateScrollJump(this.$refs.basicInformationRef, mainScrollbar);
        return;
      }

      // 费用归属校验
      if (!this.needOrganizer || this.addCostEditFlag) {
        let costValidate = await this.$refs.costAscriptionRef.validateHandler();
        if (!costValidate) return;
      }

      // 活动附件校验
      let fileValidate = await this.$refs.activityFileRef.validateHandler();
      if (!fileValidate) return;

      return true;
    },
    submitBtn: throttleAsync(async function () {
      let validateResult = await this.subValidate();
      if (!validateResult) return;

      // 保存提交类型
      let saveType = 2;
      // 请求接口
      let requestUrl = newApplicationFormApi.activityFormSubimt;

      let { editFlag } = this.$store.state.newApplication;

      // 如果是编辑则调用保存接口
      if (editFlag) {
        requestUrl = newApplicationFormApi.activityFormSave;
      }

      if (editFlag === 2) {
        // 品推编辑 编辑基本信息
        saveType = 3;
      }

      if (editFlag === 3 || editFlag === 1) {
        // 3.驳回编辑 编辑被驳回的费用归属 || 1.编辑全部
        saveType = 4;
      }

      let params = this.paramsHandler(saveType);
      // 礼品汇超时规则确认弹窗
      const tableData = this.$refs.costAscriptionRef ? this.$refs.costAscriptionRef.tableData : [];
      const allsmartConfirmed = await confirmAllsmartOrderTimeout(this, hasAllsmartOrder(tableData));
      if (!allsmartConfirmed) return;
      newApplicationFormApi.verificationActivity(params).then(res => {
        confirmPrecheck(this, res, {
          originalBizId: (params.marketActivity && params.marketActivity.activityCode) || ''
        }).then(confirmed => {
          if (confirmed) {
            this.submitRequestCommand(editFlag, params, requestUrl);
          }
        });
      }).catch(() => {
        notifyDetectFailed(this);
      });

    }, 500),
    submitRequestCommand (editFlag, params, requestUrl) {
      this.$store.commit('setSubPageLoading', true);
      requestUrl(params).then(res => {
        this.$store.commit('setSubPageLoading', false);
        confirmBusiness(this, res).then(passed => {
          if (passed) {
            this.isSubmitted = true;
            this.$message.success(this.$t('general.SubSucc'));
            // 如果是编辑页，就重定向至编辑页
            if (editFlag > 0) {
              this.$router.push({
                path: '/activityDetails',
                query: {
                  activityCode: this.$route.query.activityCode,
                  metaActive: this.$route.query.metaActive ? this.$route.query.metaActive : '/activityQuery'
                }
              });
              return;
            }

            if (this.$route.path === '/activityApplication') {
              // 费用归属提示
              let advertiseFlag = this.$refs.costAscriptionRef.tableData.some(item => {
                return item.advertiseExpenseDetails && item.advertiseExpenseDetails.advertiseOrderDetails.length > 0;
              });
              if (advertiseFlag) {
                this.$confirm(this.$t('notic.tcuafc'), this.$t('general.Hint'), {
                  confirmButtonText: this.$t('btn.OK'),
                  showCancelButton: false,
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                  showClose: false,
                  type: 'warning'
                }).then(() => {
                  this.$router.push('/activityQuery');
                }).catch(() => {
                });
              }
            }
            this.$router.push('/activityQuery');
          }
        });
      });
    },
    saveBtn () {
      let fileValidate = this.$refs.activityFileRef.validateHandler();
      if (!fileValidate) return;

      let params = this.paramsHandler(1);

      newApplicationFormApi.activityFormSave(params).then(res => {
        confirmBusiness(this, res).then(passed => {
          if (passed) {
            this.isSubmitted = true;
            this.$message.success(this.$t('general.SaveSucc'));
            this.$router.push('/drafts');
          }
        });
      });
    },
    getEchoData () {
      this.$store.commit('setSubPageLoading', true);
      newApplicationFormApi.getMarketActivityData(this.$route.query.activityCode).then(res => {
        this.$store.commit('setSubPageLoading', false);
        if (res.status === '200') {
          this.editEchoData = res.data;
          // 是否需要活动组支持
          this.$store.commit('newApplication/setNeedOrganizer', res.data.marketActivity.needOrganizer);
          if (res.data.marketActivity.needOrganizer) {
            // 活动组支持追加的费用是否可编辑
            // 000 为总部报备活动
            this.addCostEditFlag = res.data.mactExpenseBelongVOList.some(item => {
              return item.allowEdit && item.mactExpenseBelong.deptCode !== '000';
            });
          }
        }
      });
    }
  },
  mounted () {
    // 保存按钮显示隐藏：如果是申请页面 || 从草稿页来的
    this.saveBtnShow = this.$route.path === '/qdApplication' || this.$route.query.activeName === 'drafts';
    if (this.$route.query.activityCode) {
      this.pageTitle = this.$t('general.EventsEditor');
      this.isSubmitted = true;
      this.getEchoData();
      if (sessionStorage.getItem('applicationEditFlag')) {
        this.$store.commit('newApplication/setEditFlag', Number(sessionStorage.getItem('applicationEditFlag')));
      }
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('applicationEditFlag', this.$store.state.newApplication.editFlag);
      });
    }
  },
  beforeRouteLeave (to, from, next) {
    // 如果没有提交并且填写了活动名称，则提示该信息
    if (!this.isSubmitted && this.$refs.basicInformationRef.formData.activityName) {
      this.$confirm(this.$t('general.OKSad'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        this.saveBtn().then(() => {
          next();
        });
      }).catch(() => {
        next();
      });
    } else {
      sessionStorage.removeItem('applicationEditFlag');
      this.$store.commit('newApplication/setEditFlag', 0);
      next();
    }
  }
};
</script>

<style scoped>
.reportApplication .buttons {
  text-align: center;
}
</style>
